/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EnrichedMappingResultWithDepth,
    EnrichedMappingResultWithDepthFromJSON,
    EnrichedMappingResultWithDepthFromJSONTyped,
    EnrichedMappingResultWithDepthToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface EnrichedMappingResultWithDepthsListResponse
 */
export interface EnrichedMappingResultWithDepthsListResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof EnrichedMappingResultWithDepthsListResponse
     */
    msg: string;
    /**
     * 
     * @type {Array<EnrichedMappingResultWithDepth>}
     * @memberof EnrichedMappingResultWithDepthsListResponse
     */
    entries: Array<EnrichedMappingResultWithDepth>;
}

export function EnrichedMappingResultWithDepthsListResponseFromJSON(json: any): EnrichedMappingResultWithDepthsListResponse {
    return EnrichedMappingResultWithDepthsListResponseFromJSONTyped(json, false);
}

export function EnrichedMappingResultWithDepthsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnrichedMappingResultWithDepthsListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entries': ((json['entries'] as Array<any>).map(EnrichedMappingResultWithDepthFromJSON)),
    };
}

export function EnrichedMappingResultWithDepthsListResponseToJSON(value?: EnrichedMappingResultWithDepthsListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entries': ((value.entries as Array<any>).map(EnrichedMappingResultWithDepthToJSON)),
    };
}


